const entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
};

export const escapeHTML = (str) => {
  return String(str).replace(/[&<>"'/]/g, (s) => {
    return entityMap[s];
  });
};
